export const INVESTMENT_EXPERIENCE_OPTIONS = [
    {value: "NONE", name: "None"},
    {value: "YRS1_2", name: "1–2 years"},
    {value: "YRS_3_5", name: "3–5 years"},
    {value: "YRS_5_10", name: "5–10 years"},
    {value: "YRS_10", name: "10+ years"},
]